<template>
  <v-container fluid>
    <!-- First Row Starts(For Tabs) -->
    <v-row>
      <v-tabs v-model="tab" class="elevation-0" height="25px">
        <v-tabs-slider></v-tabs-slider>
        <v-tab class="text-capitalize" name="movies2">Questions</v-tab>

        <v-tab class="text-capitalize" name="setting">Master List</v-tab>
        <v-tab class="text-capitalize" name="import">Import</v-tab>
        <v-tab class="text-capitalize" name="settingInfo">Setting</v-tab>
        <v-tab class="text-capitalize" name="apisettings">API Settings</v-tab>
      </v-tabs>
    </v-row>

    <v-tabs-items v-model="tab" fluid class="mt-2">
      <v-tab-item name="movies2">
        <v-card flat tile class="mt-0">
          <Question></Question>
        </v-card>
      </v-tab-item>

      <v-tab-item name="setting">
        <v-card flat tile>
          <AllSetting></AllSetting>
        </v-card>
      </v-tab-item>
      <v-tab-item name="import">
        <v-card flat tile>
          <Import></Import>
        </v-card>
      </v-tab-item>
      <v-tab-item name="settingInfo">
        <v-card flat tile>
          <SettingInfo></SettingInfo>
        </v-card>
      </v-tab-item>

      <v-tab-item name="apisettings">
        <v-row align="center" class="mt-8" justify="center">
          <v-col cols="12" sm="8" md="4" align="center" class="mt-8">
            <v-card class="elevation-3 mt-12" max-width="300px">
              <v-card-text align="center" justify="center">
                <div style="font-size:20px" class="mt-8">
                  <b>API Key:</b>
                  {{ aPIKey }}
                </div>
                <div style="font-size:20px" class="mt-8 mb-8">
                  <b>API Password:</b>
                  {{ aPIPassword }}
                </div>
              </v-card-text>
              <v-btn
                class="secondary White--text mt-n5 mb-6"
                text
                @click="viewForAPI"
                id="Register"
              >View</v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <!-- Col Ends Here -->
    <!-- Activities Ends Here -->
  </v-container>
</template>

<script>
import Question from "../views/QuestionPage.vue";
import AllSetting from "../views/allSetting.vue";
import SettingInfo from "../views/settings.vue";
import Import from "../views/ImportPage.vue";
export default {
  components: {
    Question,
    AllSetting,
    Import,
    SettingInfo
  },
  name: "HelloWorld",

  data: () => ({
    aPIKey: "",
    aPIPassword: "",
    dialog: false,
    tab: null,
    show3: false,
    password: "Password",
    drawer: false,

    open: ["public"],
    files: {
      html: "mdi-language-html5",
      js: "mdi-nodejs",
      json: "mdi-json",
      md: "mdi-markdown",
      pdf: "mdi-file-pdf",
      png: "mdi-file-image",
      txt: "mdi-file-document-outline"
      // xls: 'mdi-file-excel',
    },
    items2: [
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me 2" }
    ],
    Add: ["Folder", "File"],
    Order: ["Date", "Name", "Size"],
    items1: ["ABC", "XYZ", "DEF", "GHI"],
    Folder: ["Excel", "Word", "PDF", "PPT", "Audio", "Video"],
    time: [
      "(UTC-11:00)Pacific/Pago_pago",
      "(UTC-12:00)Pacific/Majuro",
      "(UTC-10:00)Pacific/Honolulu"
    ]
  }),
  created() {
    this.aPIKey = this.$store.getters.get_OrgDetails.org_apikey;
    this.aPIPassword = this.$store.getters.get_OrgDetails.org_apipassword;
  },
  methods: {
    viewForAPI() {
      window.open("http://stage.adjustermate.com/Help/?v_n=Help");
    },
    test() {
      // alert(90);
      window.location.reload();
    }
  }
};
</script>
